import { createContext } from 'react';
import type { AuthContextValue } from '../types/authContext';

export const AuthContext = createContext<AuthContextValue | null>(null);
